document.addEventListener('DOMContentLoaded', function () {
  var productBlocks = document.querySelectorAll('.na-inline-product');

  productBlocks.forEach(function (block) {
    var handle = block.dataset.productHandle;
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product niet gevonden: ' + handle);
        return response.json();
      })
      .then(function (product) {
        renderProductCard(block, product);
      })
      .catch(function (error) {
        console.error(error);
        block.style.display = 'none';
      });
  });

  function renderProductCard(block, product) {
    var variant = product.variants[0];
    var price = (variant.price / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    var compareAtPrice = (variant.compare_at_price && variant.compare_at_price > variant.price)
      ? (variant.compare_at_price / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
      : null;

    block.innerHTML =
      '<a href="' + product.url + '" class="na-inline-product__image">' +
        '<img src="' + product.featured_image + '" alt="' + product.title + '" loading="lazy">' +
      '</a>' +
      '<div class="na-inline-product__info">' +
        '<a href="' + product.url + '" class="na-inline-product__title">' + product.title + '</a>' +
        '<div class="na-inline-product__price">' +
          '<span class="na-inline-product__price-now">' + price + '</span>' +
          (compareAtPrice ? '<span class="na-inline-product__price-was">' + compareAtPrice + '</span>' : '') +
        '</div>' +
        '<button type="button" class="na-inline-product__btn">In winkelwagen</button>' +
        '<span class="na-inline-product__feedback"></span>' +
      '</div>';

    var btn = block.querySelector('.na-inline-product__btn');
    btn.addEventListener('click', function () {
      addToCart(variant.id, btn, block);
    });
  }

  function addToCart(variantId, btn, block) {
    var feedback = block.querySelector('.na-inline-product__feedback');
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';
    feedback.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Kon niet toevoegen aan winkelwagen');
        return response.json();
      })
      .then(function () {
        btn.textContent = 'Toegevoegd ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'In winkelwagen';
        }, 2500);
      })
      .catch(function (error) {
        console.error(error);
        feedback.textContent = 'Er ging iets mis, probeer opnieuw.';
        btn.disabled = false;
        btn.textContent = 'In winkelwagen';
      });
  }
});